export default "__VITE_ASSET__95e9c3bf__"